import { render, staticRenderFns } from "./backend-rank.vue?vue&type=template&id=3f109a6b&"
import script from "./backend-rank.vue?vue&type=script&lang=js&"
export * from "./backend-rank.vue?vue&type=script&lang=js&"
import style0 from "./backend-rank.vue?vue&type=style&index=0&id=3f109a6b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports